import {getBlockingAsyncActionTypes, getSilentAsyncActionTypes} from './util';

export const GLOBAL__ACTIONSCOPE = 'GLOBAL_ACTION_SCOPE';

export const AUTHENTICATE__ACTIONTYPES = getBlockingAsyncActionTypes('AUTHENTICATE');
export const RENEW_AUTHENTICATION__ACTIONTYPES = getSilentAsyncActionTypes('RENEW_AUTHENTICATION');
export const LOGOUT__ACTIONTYPE = 'LOG_OUT';
export const CLEAR_AUTHENTICATION__ACTIONTYPE = 'CLEAR_AUTHENTICATION';

export const DISPLAY_ERROR__ACTIONTYPE = 'DISPLAY_ERROR';
export const DISMISS_ERROR__ACTIONTYPE = 'DISMISS_ERROR';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/constants/global.ts